import React, { useEffect, useState } from "react";
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import { ExternalLink } from "react-feather";
import { evaluacionesService } from "../../../../../_services/evaluaciones.service";
import moment from "moment";
import { fixNumber } from "../../../../../utils/utils";
import "./index.css";

const Evaluaciones = ({ show, handleClose, data }) => {
  const [key, setKey] = useState("1");
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [evaluacionData, setEvaluacionData] = useState("");
  const [actuaciones, setActuaciones] = useState({
    total: 0,
    sin_radicar: 0,
    apremios: 0,
    sin_movimientos: 0,
    sin_archivar: 0,
  });

  const [resultados, setResultados] = useState({
    a_radicar: 0,
    sin_radicar: 0,
    archivados: 0,
    sin_archivar: 0,
    restantes: 0,
    faltantes: 0,
  });

  const [porcentajes, setPorcentajes] = useState({
    a_radicar: 0,
    archivados: 0,
    faltantes: 0,
  });

  useEffect(() => {
    const getData = async () => {
      const res = await evaluacionesService.evaluacionesByAbogado({
        abogado: data.codexterno
      });

      setEvaluaciones(res);
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (evaluacionData) {
        const cantidadJuicios = JSON.parse(evaluacionData.cantidadJuicios);
        const cantidadTotal = JSON.parse(evaluacionData.cantidadTotal);

        setActuaciones(cantidadJuicios);
        setResultados(cantidadTotal);

        setPorcentajes({
          a_radicar: fixNumber((cantidadTotal?.sin_radicar * 100) / cantidadTotal?.a_radicar),
          archivados: fixNumber((cantidadTotal?.sin_archivar * 100) / cantidadTotal?.archivados),
          faltantes: fixNumber((cantidadTotal?.faltantes * 100) / cantidadTotal?.restantes),
        });
      }
    };

    getData();
  }, [evaluacionData]);

  const handleClick = (e) => {
    setEvaluacionData(e);
    setKey("2");
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        className="evaluaciones-modal"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className="p-5">
          <Tabs
            activeKey={key}
            onSelect={(k) => {
              setEvaluacionData("");
              setKey(k);
            }}
          >
            <Tab eventKey="1" title="LISTADO DE EVALUACIONES">
              {evaluaciones.map((e, i) => {
                return (
                  <div className={`d-flex evaluacion-row ${i ? "actuacion-row" : ""}`} key={`evaluacion-${i}`}>
                    <div className="p-3">{moment(new Date(e.fecha)).format("DD/MM/YYYY")}</div>
                    <div className="p-3">{moment(new Date(e.fecha)).format("HH:MM")}</div>
                    <div className={"p-3"}>
                      <div className={`badge-${e.resultado?.toLowerCase() || ""}`}>
                        {e.resultado}
                      </div>
                    </div>
                    <div className="evaluacion-accion w-full">
                      <Button className="btn-outline" onClick={() => handleClick(e)}>Ver detalles <ExternalLink className="action-table" /> </Button>
                    </div>
                  </div>
                );
              })}
            </Tab>
            {key === "2" && (
              <Tab eventKey="2" title="DETALLE DE EVALUACIÓN">
                <div className="p-3 eval-cantidad">
                  <div className="d-flex my-1">
                    <div className="juicios">Total de asignaciones:</div>
                    <div className="evaluacion-form">{actuaciones.total}</div>
                  </div>
                  <div className="d-flex my-1">
                    <div className="juicios">Total de asignaciones sin radicar:</div>
                    <div className="evaluacion-form">{actuaciones.sin_radicar}</div>
                  </div>
                  <div className="d-flex my-1">
                    <div className="juicios">Total de apremios:</div>
                    <div className="evaluacion-form">{actuaciones.apremios}</div>
                  </div>
                  <div className="d-flex my-1">
                    <div className="juicios">Total de apremios sin movimientos o faltantes:</div>
                    <div className="evaluacion-form">{actuaciones.sin_movimientos}</div>
                  </div>
                  <div className="d-flex my-1">
                    <div className="juicios">Total de apremios sin archivar:</div>
                    <div className="evaluacion-form">{actuaciones.sin_archivar}</div>
                  </div>
                </div>
                <div>
                  <table className="w-full">
                    <tr style={{ background: "#0477AD", color: "white" }}>
                      <th></th>
                      <th className="text-right py-1">% permitido</th>
                      <th className="text-right py-1">% obtenido</th>
                    </tr>
                    <tr>
                      <td className="px-2 pt-2">Porcentaje máximo de apremios sin radicar:</td>
                      <td className="px-2 pt-2 text-right">
                        <div className="d-flex align-items-center justify-content-end evaluacion-form">{evaluacionData.maximoSinRadicar} %</div>
                      </td>
                      <td className="px-2 pt-2 text-right">
                        <b className={`${porcentajes.a_radicar <= +evaluacionData.maximoSinRadicar ? "aprobado" : "desaprobado"}`}>
                          {`${porcentajes.a_radicar}%`}
                        </b>
                        <b> {`(${resultados.sin_radicar}/${resultados.a_radicar})`}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-2 pt-1">Porcentaje máximo de apremios con faltantes o sin movimientos:</td>
                      <td className="px-2 pt-1 text-right">
                        <div className="d-flex align-items-center justify-content-end evaluacion-form">{evaluacionData.maximoFaltantes} %</div>
                      </td>
                      <td className="px-2 pt-1 text-right">
                        <b className={`${porcentajes.faltantes <= +evaluacionData.maximoFaltantes ? "aprobado" : "desaprobado"}`}>
                          {`${porcentajes.faltantes}%`}
                        </b>
                        <b> {`(${resultados.faltantes}/${resultados.restantes})`}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-2 pt-1">Porcentaje máximo de apremios sin archivar:</td>
                      <td className="px-2 pt-1 text-right">
                        <div className="d-flex align-items-center justify-content-end evaluacion-form">{evaluacionData.maximoSinArchivar} %</div>
                      </td>
                      <td className="px-2 pt-1 text-right">
                        <b className={`${porcentajes.archivados <= +evaluacionData.maximoSinArchivar ? "aprobado" : "desaprobado"}`}>
                          {`${porcentajes.archivados}%`}
                        </b>
                        <b> {`(${resultados.sin_archivar}/${resultados.archivados})`}</b>
                      </td>
                    </tr>
                  </table>
                </div>
              </Tab>
            )}
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default Evaluaciones;
